const commonParticulars: {
  [key: string]: {
    key: string;
    description: string;
  };
} = {
  fee: {
    key: 'managementfee',
    description: 'Fixed Management Fees based on AUM',
  },
  charges: {
    key: 'charges',
    description: 'Custodian Fees, Depository Charges & Fund Accounting Charges',
  },
  taxes: {
    key: 'taxes',
    description: 'Goods and Service Tax, Security Transaction Tax & Other Statutory levies',
  },
  performanceFee: {
    key: 'performanceFee',
    description:
      'Performance Fee of 20% on returns in excess (S&P BSE 500 TRI) Hurdle Rate with (No Catch up) subject to a High-Water Mark – charged',
  },
  operatingCost: {
    key: 'operatingCost',
    description:
      'Subject to a cap of 0.50% p.a. of the AUM or as may be provided under the SEBI Regulations',
  },
  exitLoad: {
    key: 'exitLoad',
    description:
      'Exit load of 1% will be applicable, if redeemed within 0-6 months from date of Initial and subsequent funding for investment, Nil thereafter',
  },
};

export const particulars: {
  [key: string]: {
    [key: string]: {
      key: string;
      description: string;
    };
  };
} = {
  Fixed: {
    ...commonParticulars,
  },
  Hybrid: {
    ...commonParticulars,
    performanceFee: {
      key: 'performanceFee',
      description:
        'Variable Fee of 20% on returns in excess (S&P BSE 500 TRI) Hurdle Rate with (No Catch up) subject to a  High-Water Mark – charged',
    },
  },
};
